import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { Box, Button, Container } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useT } from '../../i18n';
import { playCue } from '../feedback';

interface Props {
    children: React.ReactNode;
    /** Where the back button goes; the previous page by default. */
    to?: string;
    onBack?: () => void;
    backLabel?: string;
    /** Let the content take the page's full height, so it can centre itself vertically. */
    fill?: boolean;
}

/** A scrolling page with a back button, above the cosmic backdrop. */
export const PageShell: React.FC<Props> = ({
    children,
    to,
    onBack,
    backLabel,
    fill,
}) => {
    const navigate = useNavigate();
    const t = useT();
    return (
        <Box
            sx={{
                flex: 1,
                minHeight: 0,
                overflowY: 'auto',
                position: 'relative',
                zIndex: 1,
            }}
        >
            <Container
                maxWidth="sm"
                sx={{
                    pb: 4,
                    ...(fill && {
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '100%',
                    }),
                }}
            >
                <Button
                    startIcon={<ArrowBackRoundedIcon />}
                    onClick={() => {
                        playCue('ui');
                        if (onBack) onBack();
                        else if (to) navigate(to);
                        else navigate(-1);
                    }}
                    sx={{ my: 1, ml: -1 }}
                >
                    {backLabel ?? t('app.back')}
                </Button>
                {children}
            </Container>
        </Box>
    );
};
